import Search from "../home/_Search";
import GenerateComparisonTable from "./_GenerateComparisonTable";
import SetLSSearchCondition from "./_SetLSSearchCondition";
import TableScroll from "./_TableScroll";

Search();
TableScroll();
GenerateComparisonTable();
SetLSSearchCondition();